import React, { useRef, useState } from 'react'

// Node Modules
import { useTranslation } from 'react-i18next'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

// Components
import { CopyIcon } from 'components/SASIcon'
import { ApplyIcon } from 'components/SASIcon'

// Styles
import styles from './CopyCode.module.scss'

interface Props {
  text: string
  code: React.ReactNode
}

const CopyCode = ({ text, code }:Props) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const val = useRef<HTMLTextAreaElement>(null)
  const btn = useRef<HTMLButtonElement>(null)

  function onCopy(event: React.MouseEvent<HTMLButtonElement>) {
    val && val.current && val.current.select()
    setCopied(true)
    document.execCommand("copy")
    
    const target:HTMLButtonElement = event.target as HTMLButtonElement
    target.focus()

    setTimeout(()=>{
      setCopied(false)
    }, 2000 )
  }

  const copyButton = (
    <button 
      ref={btn}
      className={`${styles.button} ${copied ? styles.copied : ''}`} 
      onClick={onCopy} 
      title={copied ? t('helpcenter-gui-icu.content.code.copy_button.copied.title') : ''}
      aria-label={t('helpcenter-gui-icu.content.code.copy_button.aria')}>
      <div className={`${styles.svgContainer} ${copied ? styles.hide : styles.show}`}><CopyIcon/></div>
      <div className={`${styles.svgContainer} ${copied ? styles.show : styles.hide} ${styles.check}`}><ApplyIcon /></div>
    </button>
  )

  return (
    <div className={styles.copyCode}>
      <OverlayTrigger  trigger="hover" overlay={<Tooltip id="tooltip-copy-clipboard">{t('helpcenter-gui-icu.content.code.copy_button.aria')}</Tooltip>}>
      { copyButton }
      </OverlayTrigger>
      <textarea tabIndex={-1} aria-hidden={true} ref={val} className={styles.text} defaultValue={text}></textarea>
      <div className={styles.content}>{ code }</div>
    </div>
  )
}

export default CopyCode